import React from "react";
import { CURRENCY } from "../../../contants";

const MobileOrderSummaryBanner = ({ activeOrder, grandTotal }) => {
  if (!activeOrder || !activeOrder.orderItems || activeOrder.orderItems.length === 0) {
    return null;
  }

  return (
    <div className="mobile-active-banner text-white p-3 d-flex justify-content-between align-items-center shadow-sm">
      <div className="flex-fill">
        <div className="fw-bold fs-6">
          {activeOrder.tableNumber
            ? `Table ${activeOrder.tableNumber}`
            : activeOrder.orderType}
        </div>
        <div className="small opacity-75">
          {activeOrder.branchOrderNumber} •{" "}
          {activeOrder.orderItems?.length || 0} items
        </div>
      </div>
      <div className="fs-5 fw-bold text-end">
        {CURRENCY}
        {grandTotal?.toFixed(2) || "0.00"}
      </div>
    </div>
  );
};

export default MobileOrderSummaryBanner;